import React, {ReactNode} from 'react';
import {useFormikContext} from 'formik';

import FormikRadioButtons from 'src/components/formik-radio-buttons';
import FormikTextInput from 'src/components/inputs/formik-text-input';
import InstitutionTypeaheadWithModal from 'shared/institution-typeahead/components/institution-typeahead-with-modal';
import {ActivityForm} from './activities-form-wrapper';

const TransferActivityLocation = () => {
  const formik = useFormikContext<ActivityForm>();

  let selector: ReactNode;
  switch (formik.values.where) {
    case 'school':
      selector = (
        <div className="activity-location-school">
          <InstitutionTypeaheadWithModal
            institutionType="community-college"
            fieldName="institution"
            renderLabel={() => 'College Name'}
          />
        </div>
      );
      break;
    case 'org':
      selector = (
        <div className="activity-location-organization">
          <FormikTextInput
            name="organization"
            placeholder="e.g. YMCA, Southern League, Upward Bound"
            required
          />
        </div>
      );
      break;
    default:
      selector = null;
      break;
  }

  return (
    <div className="activity-location">
      <FormikRadioButtons
        name="where"
        options={[
          {value: 'school', label: 'In College'},
          {value: 'org', label: 'Outside of School'},
        ]}
        legendText="Where did you join?"
        required
      />
      {selector}
    </div>
  );
};

export default TransferActivityLocation;
